import axios from "axios";
import { MainUrl } from "../constants";

const API_URL = `${MainUrl}/mng_shift`;

export const CreateMNGShift = async (
  token,
  userId,
  date,
  start,
  end,
  name,
  typeShiftId
) => {
  try {
    const bodyRequest = {
      date: date,
      user_id: userId,
      start: start,
      end: end,
      name: name,
      type_shift_id: typeShiftId,
    };

    const response = await axios.post(`${API_URL}/create/`, bodyRequest, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    if (error.status == 401) {
      localStorage.removeItem("token");
      localStorage.removeItem("access_level");
      window.location.href = "/";
    }
    return error.response.data;
  }
};

export const addOpenShift = async (token, date, employee, typeShiftId) => {
  const bodyRequest = {
    date: date,
    employee: employee,
    type_shift_id: typeShiftId,
  };
  try {
    const response = await axios.post(`${API_URL}/open_shift/`, bodyRequest, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    return error.response.data;
  }
};

export const DeleteShift = async (token, shiftId) => {
  try {
    const response = await axios.delete(`${API_URL}/${shiftId}`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    return error.response.data;
  }
};

export const UserShiftMNG = async (token, userId, startDate, endDate) => {
  let bodyRequest = {
    user_id: userId,
    start_date: startDate,
    end_date: endDate,
  };
  const response = await axios.post(`${API_URL}/user_shift/`, bodyRequest, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });
  return response.data;
};

export const getShiftById = async (token, shiftId) => {
  const response = await axios.get(`${API_URL}/${shiftId}`, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });
  return response.data;
};

export const RestaurantShift = async (
  token,
  startDate,
  endDate,
  restaurantId
) => {
  let bodyRequest = {
    restaurant_id: restaurantId,
    start_date: startDate,
    end_date: endDate,
  };
  const response = await axios.post(
    `${API_URL}/restaurant_shift/`,
    bodyRequest,
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    }
  );
  return response.data;
};
